import {
  API_PREFIX,
  type GenerationSummary,
  type ListGenerationsParams,
  type ListGenerationsResponse,
} from '@paint-ai/shared';
import { apiRequest } from '@/lib/api-client';

const BASE = `${API_PREFIX}/generations`;

export const generationsApi = {
  list: (params: ListGenerationsParams, signal?: AbortSignal) =>
    apiRequest<ListGenerationsResponse>(BASE, { query: { ...params }, signal }),
  stats: (signal?: AbortSignal) => apiRequest<GenerationSummary>(`${BASE}/stats`, { signal }),
  remove: (id: string) => apiRequest<void>(`${BASE}/${id}`, { method: 'DELETE' }),
  clear: () => apiRequest<void>(BASE, { method: 'DELETE' }),
};
